// extracted by mini-css-extract-plugin
export default {"input":"K7-z","button":"L7-z","selected":"M7-z","unavailable":"N7-z","oos":"O7-z","image":"P7-z","paperCutDisabledOverlay":"Q7-z"};